import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { iColorsTheme, iThemeTypes, themes } from '../interfaces/themes.interface';
import { FaviconService } from './favicon.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(
    private titleService: Title,
    private faviconService: FaviconService,
  ) {}

  setVariable(name: string, value: string): void {
    document.documentElement.style.setProperty(name, value);
  }

  setTheme(themeName: iThemeTypes) {
    const theme = themes.get(themeName);
    if (theme) {
      this.setVariables(theme.colors);
      this.titleService.setTitle(theme.title);
      this.faviconService.changeFavicon(theme.favicon);
    }
  }

  setVariables(colors: iColorsTheme) {
    this.setVariable('--primary', colors.primary);
    this.setVariable('--secondary', colors.secondary ? colors.secondary : '#fff');
    this.setVariable('--primary-dark', colors.primaryDark);
    this.setVariable('--primary-light', colors.primaryLight);
    this.setVariable('--primary-200', colors.primary200);
    this.setVariable('--primary-900', colors.primary900);
    this.setVariable('--primary-700', colors.primary700 ? colors.primary700 : '#002955')
    this.setVariable('--light-gradient', colors.lightGradient ? colors.lightGradient : '#badf69')
    this.setVariable('--dark-gradient', colors.darkGradient ? colors.darkGradient : '#487513')
    this.setVariable('--white', colors.white ? colors.white : '#fff')
  }
}